import React, { useState, useEffect } from 'react';
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';
import { ayniUrunSor } from './AyniUrunSorusu';

// API URL'i tanımlama
const baseURL = process.env.REACT_APP_API_URL;

function TeklifGirisFormu({ teklifId, onClose, onTeklifEklendi }) {
    // --- BÖLÜM 1: STATE TANIMLAMALARI (TÜM HAFIZA) ---
    
    // Müşteri ve Adres Yönetimi
    const [telefon, setTelefon] = useState('');
    const [musteriAramaSonuclari, setMusteriAramaSonuclari] = useState([]);
    const [seciliMusteri, setSeciliMusteri] = useState(null);
    const [formModu, setFormModu] = useState('gosterim');
    const [adresFormData, setAdresFormData] = useState({ id: null, ad_soyad: '', telefon_numarasi: '', adres: '', il: '', ilce: '' });
    const [isMusteriGuncellemeModu, setIsMusteriGuncellemeModu] = useState(false);
    const [musteriAdresSayisi, setMusteriAdresSayisi] = useState(1);
    const [teklifKaynagi, setTeklifKaynagi] = useState('W');
    const [odemeYontemi, setOdemeYontemi] = useState('K');
    const [makineBaskilari, setMakineBaskilari] = useState([]);
    const [makineAdetleri, setMakineAdetleri] = useState({});
    const [sepet, setSepet] = useState([]);
    const [urunAramaTerimi, setUrunAramaTerimi] = useState('');
    const [urunAramaSonuclari, setUrunAramaSonuclari] = useState([]);
    const [aktifUrun, setAktifUrun] = useState(null);
    const [aktifUrunAdet, setAktifUrunAdet] = useState('');
    const [editingCell, setEditingCell] = useState(null);
    const [kargoBedeli, setKargoBedeli] = useState(0);
    const [isKargoEditable, setIsKargoEditable] = useState(false);
    const [isKargoManuallySet, setIsKargoManuallySet] = useState(false); // Kullanıcı kargo bedelini manuel olarak değiştirdi mi?
    const [kapidaOdemeBedeli, setKapidaOdemeBedeli] = useState(0);
    const [isKapidaOdemeEditable, setIsKapidaOdemeEditable] = useState(false);
    const [indirim, setIndirim] = useState(0);
    const [isKdvApplied, setIsKdvApplied] = useState(false);
    const [genelToplam, setGenelToplam] = useState(0);
    const [ilIlceListesi, setIlIlceListesi] = useState({ iller: [], ilceler: [] });
    
    // Sistem Ayarları
    const [sistemAyarlari, setSistemAyarlari] = useState({
        kargo_ucreti: 175, // Default değer
        kapida_odeme_ucreti: 20, // Default değer
        ucretsiz_kargo_limiti: 5000, // Default değer
    });

    // Keyboard Navigation States
    const [activeElementIndex, setActiveElementIndex] = useState(0);
    const [navigableElements, setNavigableElements] = useState([]);
    
    // Ürün listesi navigasyon state'leri
    const [selectedUrunIndex, setSelectedUrunIndex] = useState(-1);

    // Müşteri listesi navigasyon state'leri
    const [selectedMusteriIndex, setSelectedMusteriIndex] = useState(-1);

    // --- BÖLÜM 2: STİLLER ---
    const baseButtonStyle = { width: '35px', height: '35px', fontSize: '20px', fontWeight: '600', color: 'white', border: '2px solid transparent', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s ease-in-out' };
    const sourceStyles = { W: { backgroundColor: '#26D367' }, S: { backgroundColor: '#3783c2' }, R: { backgroundColor: '#f4bf4a' } };
    const paymentStyles = { K: { backgroundColor: '#17bebb' }, E: { backgroundColor: '#6761a8' }, O: { backgroundColor: '#2c6184' }, D: { backgroundColor: '#bb999c' }, B: { backgroundColor: '#a32e68' } };
    const tableCellStyle = { borderBottom: '1px solid #e2e2e2', padding: '12px 8px', verticalAlign: 'middle' };
    const textRight = { textAlign: 'right' };
    const textCenter = { textAlign: 'center' };
    const iconStyle = { marginLeft: '8px', cursor: 'pointer' };
    // --- BÖLÜM 3: VERİ ÇEKME VE İZLEME (useEffect) ---

    // Component ilk yüklendiğinde veya düzenleme modunda açıldığında çalışır
   useEffect(() => {
        // Sadece yeni sipariş için formu sıfırla, düzenleme modunda sıfırlama
        if (!teklifId) {
            handleFormTemizle();
        }
        
        // Genel verileri çek
        fetch(`api/konum/iller`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json()).then(data => setIlIlceListesi(prev => ({ ...prev, iller: data })));
        fetch(`api/urunler/makine-baskisi`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json()).then(data => setMakineBaskilari(data));
            
        // Sistem ayarlarını çek
        fetch(`api/ayarlar`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (!data.hata) {
                    setSistemAyarlari({
                        kargo_ucreti: data.kargo_ucreti || 175,
                        kapida_odeme_ucreti: data.kapida_odeme_ucreti || 20,
                        ucretsiz_kargo_limiti: data.ucretsiz_kargo_limiti || 5000
                    });
                } else {
                    console.error("Sistem ayarları çekilemedi:", data.hata);
                }
            })
            .catch(err => {
                console.error("Sistem ayarları çekilirken hata:", err);
            });

        // Eğer bir teklifId prop'u geldiyse, bu DÜZENLEME modudur.
            if (teklifId) {
                fetch(`${baseURL}/api/teklifler/${teklifId}`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
                    .then(res => {
                        if (!res.ok) throw new Error('Teklif bulunamadı.');
                        return res.json();
                })
                .then(data => {
                    console.log('📥 BACKEND\'DEN GELEN TEKLİF VERİSİ:', data);
                    
                    if (data && data.musteri) {
                        const cleanData = {
                        ...data,
                        kargo_ucreti: data.kargo_ucreti ?? 0,
                        kapida_odeme_ucreti: data.kapida_odeme_ucreti ?? 0,
                        indirim: data.indirim ?? 0,
                        kdv_tutari: data.kdv_tutari ?? 0
                        };

                        // Formu gelen verilerle doldur
                        setTelefon(cleanData.musteri.telefon_numarasi);
                        setSeciliMusteri(cleanData.musteri);
                        setMusteriAdresSayisi(cleanData.musteri.musteri_adres_sayisi || 1);
                        setTeklifKaynagi(cleanData.teklif_kaynagi);
                        setOdemeYontemi(cleanData.odeme_yontemi);

                        // Sepet + makine adetleri
                        const initialMakineAdetleri = {};
                        const sepetUrunleri = cleanData.sepet.map(urun => {
                        if (urun.isMakine) initialMakineAdetleri[urun.id] = urun.adet;
                        return urun;
                        });
                        setSepet(sepetUrunleri);
                        setMakineAdetleri(initialMakineAdetleri);

                        // EDIT MODU → geleni olduğu gibi göster; otomatik varsayılan yazma
                        setIsKargoEditable(true);
                        setIsKapidaOdemeEditable(true);
                        setKargoBedeli(cleanData.kargo_ucreti);
                        setIsKargoManuallySet(false); // Teklif yüklendiğinde manuel değişiklik flag'ini sıfırla
                        setKapidaOdemeBedeli(cleanData.kapida_odeme_ucreti);
                        setIndirim(cleanData.indirim);
                        setIsKdvApplied(cleanData.kdv_tutari > 0);
                        
                        console.log('✅ Teklif verileri forma yüklendi');
                    } else {
                        alert("Teklif detayları yüklenemedi.");
                        onClose(false);
                    }
                    })
                    .catch(err => {
                        console.error('❌ Teklif yükleme hatası:', err);
                        alert('Teklif yüklenirken hata oluştu: ' + err.message);
                        onClose(false);
                    });
            }
    // Bağımlılıklar artık prop'lardan geliyor
    }, [teklifId]); 

    // Telefon numarası değiştiğinde müşteri arar (sadece yeni sipariş modunda)
    useEffect(() => {
        if (teklifId && !isMusteriGuncellemeModu) {
        return;
        }

        if (telefon.length < 10) {
            setSeciliMusteri(null); setMusteriAramaSonuclari([]);
            return;
        }
        const timer = setTimeout(() => {
        fetch(`api/musteriler/telefon/${telefon}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.length === 0) {
                    setSeciliMusteri({ id: null, ad_soyad: `xxxx${telefon.slice(-4)}` });
                    setMusteriAramaSonuclari([]);
                } else if (data.length === 1 && !teklifId) { // Sadece yeni siparişte otomatik seç
                    handleMusteriSecimi(data[0]);
                } else {
                    setMusteriAramaSonuclari(data);
                    // Düzenleme modunda veya müşteri güncelleme modunda seçili müşteriyi temizle
                    if (!teklifId || isMusteriGuncellemeModu) {
                       setSeciliMusteri(null);
                    }
                }
            });
    }, 500);
    return () => clearTimeout(timer);
    }, [telefon, teklifId, isMusteriGuncellemeModu]);
    
    // Ürün arama effect'i
    useEffect(() => {
        if (aktifUrun && urunAramaTerimi === aktifUrun.urun_adi) return;
        if (urunAramaTerimi.length < 2) { setUrunAramaSonuclari([]); return; }
        const timer = setTimeout(() => {
            fetch(`api/urunler/arama/${urunAramaTerimi}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then(r => r.json()).then(data => setUrunAramaSonuclari(data));
        }, 300);
        return () => clearTimeout(timer);
    }, [urunAramaTerimi, aktifUrun]);

    // Seçili ürünü görebilmek için scroll yönetimi
    useEffect(() => {
        if (selectedUrunIndex >= 0 && urunAramaSonuclari.length > 0) {
            // Seçili ürün elementini bul
            const selectedElement = document.querySelector(`[data-urun-index="${selectedUrunIndex}"]`);
            if (selectedElement) {
                // Elementin içinde bulunduğu scrollable container'ı bul
                const scrollContainer = selectedElement.closest('.urun-listesi-container');
                if (scrollContainer) {
                    selectedElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                }
            }
        }
    }, [selectedUrunIndex, urunAramaSonuclari]);

    // Finansal hesaplama effect'i
    useEffect(() => {
        const araToplam = sepet.reduce((acc, urun) => acc + ((urun.fiyat || 0) * (urun.adet || 0)), 0);

        // B (Ücretsiz Gönderi) seçildiğinde tüm ücretler 0 olmalı
        if (odemeYontemi === 'B') {
            setKargoBedeli(0);
            setKapidaOdemeBedeli(0);
            setGenelToplam(0);  // B için toplam 0 TL
            return;  // Diğer hesaplamaları atla
        }

        // Yeni sipariş modunda otomatikleri uygula
        if (!teklifId) {
            if (!isKargoEditable) {
            const otomatikKargoBedeli = (araToplam > 0 && araToplam < sistemAyarlari.ucretsiz_kargo_limiti) ? sistemAyarlari.kargo_ucreti : 0;
            setKargoBedeli(otomatikKargoBedeli);
            }
            if (!isKapidaOdemeEditable) {
            const otomatikKapidaOdeme = (odemeYontemi === 'K') ? sistemAyarlari.kapida_odeme_ucreti : 0;
            setKapidaOdemeBedeli(otomatikKapidaOdeme);
            }
        } else {
            // Düzenleme modunda da dinamik ücretsiz kargo kontrolü yap
            // Sadece kullanıcı manuel olarak değiştirmediyse otomatik kontrol yap
            if (!isKargoManuallySet) {
                if (araToplam >= sistemAyarlari.ucretsiz_kargo_limiti) {
                    // Limit aşılmış → kargo bedeli 0 olmalı
                    if (kargoBedeli > 0) {
                        console.log(`🚚 Ücretsiz kargo limiti aşıldı! Kargo bedeli sıfırlanıyor (${araToplam} >= ${sistemAyarlari.ucretsiz_kargo_limiti})`);
                        setKargoBedeli(0);
                    }
                } else {
                    // Limit aşılmamış → kargo bedeli olmalı
                    if (kargoBedeli === 0 && araToplam > 0) {
                        console.log(`🚛 Kargo limiti altına düştü! Kargo bedeli ekleniyor (${araToplam} < ${sistemAyarlari.ucretsiz_kargo_limiti})`);
                        setKargoBedeli(sistemAyarlari.kargo_ucreti);
                    }
                }
            }
        }

        // İndirim/Ek bedel hesaplama: pozitif değer = ek bedel (+), negatif değer = indirim (-)
        const matrah = Math.max(0, araToplam + indirim);
        const kdvTutari = isKdvApplied ? matrah * 0.20 : 0;
        const nihaiToplam = matrah + kdvTutari + kargoBedeli + kapidaOdemeBedeli;

        setGenelToplam(nihaiToplam);
        }, [
        sepet,
        odemeYontemi,
        indirim,
        isKdvApplied,
        isKargoEditable,
        isKapidaOdemeEditable,
        kargoBedeli,
        kapidaOdemeBedeli,
        teklifId,
        sistemAyarlari,
        isKargoManuallySet
        ]);

    // İl/İlçe mantığı için effect
    useEffect(() => {
        const aktifIl = (formModu === 'duzenleme' || formModu === 'yeniKayit') 
            ? adresFormData.il 
            : seciliMusteri?.il;

        if (aktifIl) {
            fetch(`api/konum/ilceler/${aktifIl}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then(res => res.json())
                .then(data => setIlIlceListesi(prev => ({ ...prev, ilceler: data })));
        } else {
            setIlIlceListesi(prev => ({ ...prev, ilceler: [] }));
        }
    }, [seciliMusteri, adresFormData.il, formModu]);

    // ESC tuşu ile modal kapatma
    useEffect(() => {
        const handleKeyPress = (e) => {
            // ESC tuşuna basıldığında modal'ı kapat
            if (e.key === 'Escape') {
                e.preventDefault();
                onClose(false);
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [onClose]);

    // Yeni sipariş formunda telefon alanına otomatik focus
    useEffect(() => {
        // Sadece yeni sipariş modunda (teklifId yoksa) telefon alanına focus ver
        if (!teklifId) {
            const telefonInput = document.querySelector('[data-nav-id="telefon-input"]');
            if (telefonInput) {
                // Kısa bir delay ile focus ver (modal açılmasını bekle)
                setTimeout(() => {
                    telefonInput.focus();
                }, 100);
            }
        }
    }, [teklifId]);

    // Navigation elementi güncellemek için useEffect
    useEffect(() => {
        updateNavigableElements();
    }, [formModu, makineBaskilari, sepet]);

    // Ürün arama sonuçları değiştiğinde seçim index'ini sıfırla
    useEffect(() => {
        setSelectedUrunIndex(-1);
    }, [urunAramaSonuclari]);

    // Müşteri arama sonuçları değiştiğinde seçim index'ini sıfırla
    useEffect(() => {
        setSelectedMusteriIndex(-1);
    }, [musteriAramaSonuclari]);

    // Seçili müşteriyi görebilmek için scroll yönetimi
    useEffect(() => {
        if (selectedMusteriIndex >= 0 && musteriAramaSonuclari.length > 0) {
            // Seçili müşteri elementini bul
            const selectedElement = document.querySelector(`[data-musteri-index="${selectedMusteriIndex}"]`);
            if (selectedElement) {
                // Elementin içinde bulunduğu scrollable container'ı bul
                const scrollContainer = selectedElement.closest('.musteri-listesi-container');
                if (scrollContainer) {
                    selectedElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'nearest'
                    });
                }
            }
        }
    }, [selectedMusteriIndex, musteriAramaSonuclari]);

    // --- BÖLÜM 4: OLAY YÖNETİCİLERİ (handle... fonksiyonları) ---

    const handleKaynakSecimi = (kaynak) => setTeklifKaynagi(kaynak);
    const handleOdemeYontemiSecimi = (yontem) => {
        setOdemeYontemi(yontem);
        
        // B (Ücretsiz Gönderi) seçildiğinde tüm ücretler 0 olmalı
        if (yontem === 'B') {
            setKapidaOdemeBedeli(0);
            setKargoBedeli(0);
        }
        // Eğer manuel düzenleme aktif değilse ve kapıda ödeme seçildiyse bedeli otomatik ayarla
        else if (yontem === 'K') {
            setKapidaOdemeBedeli(sistemAyarlari.kapida_odeme_ucreti);
        } else {
            setKapidaOdemeBedeli(0);
        }
        };

    const handleMusteriSecimi = (musteri) => {
        setSeciliMusteri(musteri);
        setMusteriAramaSonuclari([]);
        setIsMusteriGuncellemeModu(false);
    };
    
    const handleYeniKayitClick = () => {
        setAdresFormData({
            ad_soyad: '',
            telefon_numarasi: telefon,
            adres: '', il: '', ilce: ''
        });
        setFormModu('yeniKayit');
        // Müşteri güncelleme modunu kapat
        setIsMusteriGuncellemeModu(false);
        setMusteriAramaSonuclari([]);
    };
    
    const handleDuzenleClick = () => {
        if (!seciliMusteri) return;
        setAdresFormData({ ...seciliMusteri });
        setFormModu('duzenleme');
    };

    const handleFormIptal = () => {
        setAdresFormData({ id: null, ad_soyad: '', telefon_numarasi: '', adres: '', il: '', ilce: '' });
        setFormModu('gosterim');
    };

     const numberInputStyleOverrides = `
      /* Adet girişlerindeki okları gizler */
      /* Chrome, Safari, Edge, Opera için */
      input[type=number]::-webkit-inner-spin-button,
      input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox için */
      input[type=number] {
        -moz-appearance: textfield;
      }
    `;
    
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setAdresFormData(prev => {
            const newState = { ...prev, [name]: value };
            if (name === 'il') newState.ilce = '';
            return newState;
        });
    };
    
    const handleKaydet = async () => {
        const payload = {
            ad_soyad: (adresFormData.ad_soyad || '').trim(),
            telefon_numarasi: (adresFormData.telefon_numarasi || telefon || '').trim(),
            adres: (adresFormData.adres || '').trim(),
            il: (adresFormData.il || '').trim(),
            ilce: (adresFormData.ilce || '').trim()
        };

        if (!payload.ad_soyad || !payload.telefon_numarasi) {
            alert('Ad Soyad ve Telefon zorunludur.');
            return;
        }

        const isDuzenleme = formModu === 'duzenleme' && !!adresFormData.id;
        const endpoint = isDuzenleme
            ? `${baseURL}/api/musteriler/${adresFormData.id}`
            : `${baseURL}/api/musteriler`;

        try {
            const response = await fetch(endpoint, {
                method: isDuzenleme ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.hata || 'Müşteri kaydedilemedi.');
            }

            const kaydedilenMusteri = data.musteri || {
                ...payload,
                id: adresFormData.id
            };

            alert(data.mesaj || (isDuzenleme ? 'Müşteri başarıyla güncellendi!' : 'Müşteri başarıyla kaydedildi!'));
            setSeciliMusteri(kaydedilenMusteri);
            setTelefon(kaydedilenMusteri.telefon_numarasi || payload.telefon_numarasi);
            setMusteriAramaSonuclari([]);
            setIsMusteriGuncellemeModu(false);
            setFormModu('gosterim');
        } catch (error) {
            console.error('Müşteri kaydetme/güncelleme hatası:', error);
            alert(`Hata: ${error.message}`);
        }
    };

    const handleMakineAdetChange = (urunId, adet) => {
        const sayisalAdet = Math.max(0, parseInt(adet) || 0);
        const urun = makineBaskilari.find(u => u.id === urunId);
        if (!urun) return;
        setMakineAdetleri(prev => ({ ...prev, [urunId]: sayisalAdet }));
        setSepet(mevcutSepet => {
            const urunIndex = mevcutSepet.findIndex(item => item.id === urunId && item.isMakine);
            if (sayisalAdet === 0) {
                return urunIndex > -1 ? mevcutSepet.filter((_, index) => index !== urunIndex) : mevcutSepet;
            }
            const guncelUrun = { ...urun, adet: sayisalAdet, isMakine: true };
            if (urunIndex > -1) {
                const yeniSepet = [...mevcutSepet];
                yeniSepet[urunIndex] = guncelUrun;
                return yeniSepet;
            } else {
                return [...mevcutSepet, guncelUrun];
            }
        });
    };
    
    const handleUrunSecimiFromAutocomplete = (urun, focusToAdet = false) => {
        setAktifUrun(urun);
        setUrunAramaTerimi(urun.urun_adi);
        setUrunAramaSonuclari([]);
        setSelectedUrunIndex(-1); // Reset selection
        
        // Sadece klavye ile seçim yapıldığında adet alanına focus yap
        if (focusToAdet) {
            setTimeout(() => {
                const adetInput = document.querySelector('[data-nav-id="urun-adet-input"]');
                if (adetInput) {
                    adetInput.focus();
                }
            }, 100);
        }
    };

    // Ürün arama listesi keyboard navigation
    const handleUrunAramaKeyDown = (e) => {
        // Liste açık değilse normal davranış
        if (urunAramaSonuclari.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                setSelectedUrunIndex(prev => 
                    prev < urunAramaSonuclari.length - 1 ? prev + 1 : 0
                );
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                setSelectedUrunIndex(prev => 
                    prev > 0 ? prev - 1 : urunAramaSonuclari.length - 1
                );
                break;
                
            case 'Enter':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                if (selectedUrunIndex >= 0 && selectedUrunIndex < urunAramaSonuclari.length) {
                    handleUrunSecimiFromAutocomplete(urunAramaSonuclari[selectedUrunIndex], true);
                }
                break;
                
            case 'Escape':
                e.preventDefault();
                e.stopPropagation();
                setUrunAramaSonuclari([]);
                setSelectedUrunIndex(-1);
                break;
        }
    };
    
    // Müşteri arama listesi keyboard navigation
    const handleMusteriAramaKeyDown = (e) => {
        // Liste açık değilse normal davranış
        if (musteriAramaSonuclari.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                setSelectedMusteriIndex(prev => 
                    prev < musteriAramaSonuclari.length - 1 ? prev + 1 : 0
                );
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                setSelectedMusteriIndex(prev => 
                    prev > 0 ? prev - 1 : musteriAramaSonuclari.length - 1
                );
                break;
                
            case 'Enter':
                e.preventDefault();
                e.stopPropagation(); // Event'in başka yerlere yayılmasını engelle
                if (selectedMusteriIndex >= 0 && selectedMusteriIndex < musteriAramaSonuclari.length) {
                    handleMusteriSecimi(musteriAramaSonuclari[selectedMusteriIndex]);
                }
                break;
                
            case 'Escape':
                e.preventDefault();
                e.stopPropagation();
                setMusteriAramaSonuclari([]);
                setSelectedMusteriIndex(-1);
                break;
        }
    };
    
    const handleSepeteEkle = async () => {
        if (!aktifUrun || !aktifUrunAdet || aktifUrunAdet <= 0) return alert("Lütfen ürün ve adet seçin.");
        // Ürün sepette zaten varsa: ayrı kalem (farklı fiyat verilebilsin) ya da mevcut kaleme ekle
        let ayriKalem = false;
        if (sepet.some(u => u.id === aktifUrun.id && !u.isMakine)) {
            const secim = await ayniUrunSor(aktifUrun.urun_adi);
            if (!secim) return; // Vazgeçildi: alanlar korunur
            ayriKalem = secim === 'yeni';
        }
        setSepet(mevcutSepet => {
            const mevcutUrunIndex = ayriKalem ? -1 : mevcutSepet.findIndex(u => u.id === aktifUrun.id && !u.isMakine);
            if (mevcutUrunIndex > -1) {
                const yeniSepet = [...mevcutSepet];
                yeniSepet[mevcutUrunIndex] = { ...yeniSepet[mevcutUrunIndex], adet: yeniSepet[mevcutUrunIndex].adet + parseInt(aktifUrunAdet) };
                return yeniSepet;
            } else {
                return [...mevcutSepet, { ...aktifUrun, adet: parseInt(aktifUrunAdet), isMakine: false }];
            }
        });
        setAktifUrun(null);
        setUrunAramaTerimi('');
        setAktifUrunAdet('');
        
        // Ürün eklendikten sonra ürün arama alanına focus yap
        setTimeout(() => {
            const urunAramaInput = document.querySelector('[data-nav-id="urun-arama-input"]');
            if (urunAramaInput) {
                urunAramaInput.focus();
            }
        }, 100);
    };

    // Navigable elements'i güncelleyen fonksiyon
    const updateNavigableElements = () => {
        const elements = [];
        
        // 1. Telefon input
        elements.push({ id: 'telefon-input', type: 'input', label: 'Telefon' });
        
        // 2. Adres formu (eğer gözüküyorsa)
        if (formModu !== 'gosterim') {
            elements.push({ id: 'ad-soyad-input', type: 'input', label: 'Ad Soyad' });
            elements.push({ id: 'telefon-form-input', type: 'input', label: 'Telefon Form' });
            elements.push({ id: 'adres-input', type: 'input', label: 'Adres' });
            elements.push({ id: 'il-select', type: 'select', label: 'İl' });
            elements.push({ id: 'ilce-select', type: 'select', label: 'İlçe' });
        }
        
        // 3. Makine baskıları
        makineBaskilari.forEach((baski, index) => {
            elements.push({ id: `makine-${baski.id}`, type: 'input', label: `Makine ${baski.baski_metni}` });
        });
        
        // 4. Ürün arama ve ekleme
        elements.push({ id: 'urun-arama-input', type: 'input', label: 'Ürün Arama' });
        elements.push({ id: 'urun-adet-input', type: 'input', label: 'Ürün Adeti' });
        elements.push({ id: 'urun-ekle-button', type: 'button', label: 'Ürün Ekle' });
        
        // 7. Kargo ve diğer bedeller
        elements.push({ id: 'kargo-edit-button', type: 'button', label: 'Kargo Düzenle' });
        elements.push({ id: 'kapida-odeme-edit-button', type: 'button', label: 'Kapıda Ödeme Düzenle' });
        elements.push({ id: 'indirim-input', type: 'input', label: 'İndirim' });
        elements.push({ id: 'kdv-checkbox', type: 'checkbox', label: 'KDV' });
        
        // 8. Alt butonlar
        elements.push({ id: 'vazgec-button', type: 'button', label: 'Vazgeç' });
        elements.push({ id: 'kaydet-button', type: 'button', label: 'Kaydet' });
        
        setNavigableElements(elements);
    };

    // Arrow key navigation ve Enter tuşu ile ürün ekleme fonksiyonu
    const handleKeyDown = (e) => {
        // Enter tuşu - ürün ekleme işlevi (sadece ürün ve adet dolu ise)
        if (e.key === 'Enter' && !e.ctrlKey && !e.altKey) {
            // Eğer ürün arama listesi açıksa, o kısımda handle edilsin
            if (urunAramaSonuclari.length > 0) {
                return; // Ürün arama kısmı kendi handle eder
            }
            
            // Ürün ve adet dolu ise sepete ekle
            if (aktifUrun && aktifUrunAdet && aktifUrunAdet > 0) {
                e.preventDefault();
                handleSepeteEkle();
                return;
            }
            // Dolu değilse hiçbir şey yapma, uyarı verme
        }
        
        // Arrow key navigation
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            e.preventDefault();
            
            if (navigableElements.length === 0) {
                updateNavigableElements();
                return;
            }
            
            let newIndex = activeElementIndex;
            
            switch(e.key) {
                case 'ArrowUp':
                    newIndex = Math.max(0, activeElementIndex - 1);
                    break;
                case 'ArrowDown':
                    newIndex = Math.min(navigableElements.length - 1, activeElementIndex + 1);
                    break;
                case 'ArrowLeft':
                    // Grup içinde sol hareket (örn: kaynak butonları arası)
                    newIndex = Math.max(0, activeElementIndex - 1);
                    break;
                case 'ArrowRight':
                    // Grup içinde sağ hareket
                    newIndex = Math.min(navigableElements.length - 1, activeElementIndex + 1);
                    break;
            }
            
            setActiveElementIndex(newIndex);
            focusElement(navigableElements[newIndex]);
        }
        
        // Enter (Ctrl+Enter) - aktif elementi tetikle
        if (e.key === 'Enter' && e.ctrlKey) {
            e.preventDefault();
            const activeElement = navigableElements[activeElementIndex];
            if (activeElement) {
                triggerElement(activeElement);
            }
        }
    };

    // Element'e focus verilmesi
    const focusElement = (element) => {
        const domElement = document.querySelector(`[data-nav-id="${element.id}"]`);
        if (domElement) {
            domElement.focus();
            domElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };

    // Element'i tetikleme (click, select etc.)
    const triggerElement = (element) => {
        const domElement = document.querySelector(`[data-nav-id="${element.id}"]`);
        if (domElement) {
            if (element.type === 'button') {
                domElement.click();
            } else if (element.type === 'input') {
                domElement.focus();
                domElement.select();
            }
        }
    };

    // Makine baskıları için özel keyboard handler
    const handleMakineKeyDown = (e, currentIndex) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            
            // Sonraki makine input'una geç
            const nextIndex = currentIndex + 1;
            if (nextIndex < makineBaskilari.length) {
                const nextInput = document.querySelector(`[data-nav-id="makine-${makineBaskilari[nextIndex].id}"]`);
                if (nextInput) {
                    nextInput.focus();
                }
            } else {
                // Son makine inputundan sonra ürün arama alanına geç
                const urunAramaInput = document.querySelector(`[data-nav-id="urun-arama-input"]`);
                if (urunAramaInput) {
                    urunAramaInput.focus();
                }
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = currentIndex + 1;
            if (nextIndex < makineBaskilari.length) {
                const nextInput = document.querySelector(`[data-nav-id="makine-${makineBaskilari[nextIndex].id}"]`);
                if (nextInput) {
                    nextInput.focus();
                }
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = currentIndex - 1;
            if (prevIndex >= 0) {
                const prevInput = document.querySelector(`[data-nav-id="makine-${makineBaskilari[prevIndex].id}"]`);
                if (prevInput) {
                    prevInput.focus();
                }
            }
        }
    };

    const handleSepetChange = (index, field, value) => {
        const yeniSepet = [...sepet];
        yeniSepet[index][field] = parseFloat(value) || 0;
        setSepet(yeniSepet);
    };

    // Aynı ürün ayrı kalemlerde olabileceği için silme satır index'i ile yapılır
    const handleSepetUrunSil = (indexToRemove) => {
        const silinen = sepet[indexToRemove];
        if (!silinen) return;
        if (silinen.isMakine) {
            handleMakineAdetChange(silinen.id, 0);
        } else {
            setSepet(mevcutSepet => mevcutSepet.filter((_, i) => i !== indexToRemove));
        }
    };

    const handleFormTemizle = () => {
        setTelefon('');
        setSeciliMusteri(null);
        setMusteriAramaSonuclari([]);
        setFormModu('gosterim');
        setAdresFormData({ id: null, ad_soyad: '', telefon_numarasi: '', adres: '', il: '', ilce: '' });
        setTeklifKaynagi('W');
        setOdemeYontemi('K');
        setMakineAdetleri({});
        setSepet([]);
        setUrunAramaTerimi('');
        setAktifUrun(null);
        setAktifUrunAdet('');
        setIndirim(0);
        setIsKdvApplied(false);
        // Kargo ve kapıda ödeme değerlerini sistem ayarlarından al
        // İlk açılışta değerlerin 0 olması lazım, hesaplama useEffect'i otomatik ayarlayacak
        setKargoBedeli(0);
        setIsKargoEditable(false);
        setIsKargoManuallySet(false); // Manuel değişiklik flag'ini sıfırla
        setKapidaOdemeBedeli(0);
        setIsKapidaOdemeEditable(false);
    };

    const handleSubmit = () => {
        if (!seciliMusteri) return alert("Lütfen bir müşteri seçin.");
        if (sepet.length === 0) return alert("Sepet boş.");
        
        const araToplam = sepet.reduce((acc, urun) => acc + (urun.fiyat * urun.adet), 0);
        const kdvTutari = isKdvApplied ? (araToplam + indirim) * 0.20 : 0;
        
        // Backend'e gönderilecek veri yapısı
        const teklifData = {
            teklif: {
                teklif_kaynagi: teklifKaynagi,
                odeme_yontemi: odemeYontemi,
                kargo_ucreti: Number(kargoBedeli) || 0,
                kapida_odeme_ucreti: Number(kapidaOdemeBedeli) || 0,
                indirim: Number(indirim) || 0,
                toplam_bedel: Number(genelToplam) || 0,
                kdv_tutari: Number(kdvTutari) || 0,
                ara_toplam: Number(araToplam) || 0,
                has_makine_baskisi: sepet.some(u => u.isMakine),
                has_ozel_baskisi: false
            },
            musteri: {
                id: seciliMusteri.id,
                ad_soyad: seciliMusteri.ad_soyad,
                telefon_numarasi: seciliMusteri.telefon_numarasi
            },
            sepet: sepet.map(urun => ({
                id: urun.id,
                urun_adi: urun.urun_adi,
                adet: parseInt(urun.adet) || 0,
                fiyat: parseFloat(urun.fiyat) || 0
            }))
        };
        
        console.log('📤 BACKEND\'E GÖNDERİLEN TEKLIF VERİSİ:', JSON.stringify(teklifData, null, 2));
        
        // Düzenleme mi yoksa yeni kayıt mı?
        const url = teklifId 
            ? `${baseURL}/api/teklifler/${teklifId}` 
            : `${baseURL}/api/teklifler/yeni`;
        const method = teklifId ? 'PUT' : 'POST';
        
        console.log(`🔄 ${method} isteği gönderiliyor: ${url}`);
        
        // Backend'e istek gönder
        fetch(url, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(teklifData)
        })
        .then(res => {
            if (!res.ok) {
                return res.json().then(err => {
                    throw new Error(err.hata || 'Teklif kaydedilemedi');
                });
            }
            return res.json();
        })
        .then(data => {
            console.log('✅ BACKEND CEVABI:', data);
            const mesaj = teklifId 
                ? 'Teklif başarıyla güncellendi!' 
                : 'Teklif başarıyla kaydedildi!';
            
            alert(mesaj);
            
            // Yeni teklif eklendiyse listeyi yenile
            if (onTeklifEklendi) {
                onTeklifEklendi(data);
            }
            
            // Formu kapat ve listeyi yenile
            onClose(true);
        })
        .catch(err => {
            console.error('❌ TEKLIF KAYDETME HATASI:', err);
            alert('Teklif kaydedilirken hata oluştu: ' + err.message);
        });
    };

    return (
        <form
            onKeyDown={handleKeyDown}
            style={{
                maxWidth: '834px',      // Figma'dan gelen genişlik (daha küçük ekranlar için esnek)
                minHeight: 'auto',  // Figma'dan gelen başlangıç yüksekliği (içerik arttıkça uzayabilir)
                margin: '0',    // Sayfada ortalamak ve üstten/alttan boşluk vermek için
                background: '#F2F2F2',  // Tasarımdaki gibi beyaz bir zemin
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)', // Figma'dan gelen gölge
                border: '0px solid #C2C2C2', // Figma'dan gelen çerçeve (outline yerine border kullandım)
                borderRadius: '8px',    // Tasarıma uygun olarak köşeleri hafif yuvarlak yapalım
                padding: '20px'         // İçerik ile çerçeve arasına boşluk koyalım
            }}>
            <style>{numberInputStyleOverrides}</style>

            {/* DEMO UYARI BANNER */}
            <div style={{
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                padding: '10px',
                marginBottom: '15px',
                color: '#856404',
                textAlign: 'center',
                fontSize: '14px'
            }}>
                <strong>📋 TEKLIF FORMU:</strong> Bu form teklif amaçlıdır. Gerçek sipariş değildir ve stoklar etkilenmez.
            </div>

            {/* ÜST KONTROL PANELİ */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <strong style={{ fontWeight: '500' }}>Teklif Kaynağı</strong>
                    <button
                        type="button" 
                        onClick={() => handleKaynakSecimi('W')}
                        style={{ ...baseButtonStyle, ...sourceStyles.W, opacity: teklifKaynagi === '' || teklifKaynagi === 'W' ? 1 : 0.25 }}
                    >
                        W
                    </button>
                    <button
                        type="button" 
                        onClick={() => handleKaynakSecimi('S')}
                        style={{ ...baseButtonStyle, ...sourceStyles.S, opacity: teklifKaynagi === '' || teklifKaynagi === 'S' ? 1 : 0.25 }}
                    >
                        S
                    </button>
                    <button
                        type="button"
                        onClick={() => handleKaynakSecimi('R')}
                        style={{ ...baseButtonStyle, ...sourceStyles.R, opacity: teklifKaynagi === '' || teklifKaynagi === 'R' ? 1 : 0.25 }}
                    >
                        R
                    </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <strong style={{ fontWeight: '500' }}>Ödeme Yöntemi</strong>
                    <button
                        type="button" 
                        onClick={() => handleOdemeYontemiSecimi('K')}
                        style={{ ...baseButtonStyle, ...paymentStyles.K, opacity: odemeYontemi === '' || odemeYontemi === 'K' ? 1 : 0.25 }}
                    >
                        K
                    </button>
                    <button
                        type="button"
                        onClick={() => handleOdemeYontemiSecimi('E')}
                        style={{ ...baseButtonStyle, ...paymentStyles.E, opacity: odemeYontemi === '' || odemeYontemi === 'E' ? 1 : 0.25 }}
                    >
                        E
                    </button>
                    <button
                        type="button" 
                        onClick={() => handleOdemeYontemiSecimi('O')}
                        style={{ ...baseButtonStyle, ...paymentStyles.O, opacity: odemeYontemi === '' || odemeYontemi === 'O' ? 1 : 0.25 }}
                    >
                        O
                    </button>
                    <button
                        type="button" 
                        onClick={() => handleOdemeYontemiSecimi('D')}
                        style={{ ...baseButtonStyle, ...paymentStyles.D, opacity: odemeYontemi === '' || odemeYontemi === 'D' ? 1 : 0.25 }}
                    >
                        D
                    </button>
                    <button
                        type="button" 
                        onClick={() => handleOdemeYontemiSecimi('B')}
                        style={{ ...baseButtonStyle, ...paymentStyles.B, opacity: odemeYontemi === '' || odemeYontemi === 'B' ? 1 : 0.25 }}
                    >
                        B
                    </button>
                </div>
            </div>

            {/* ANA GÖVDE */}
            <div style={{ 
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'flex-start', 
                    background: '#F8F8F8',          // Figma'dan gelen ana zemin rengi
                    border: '1px solid #C2C2C2',    // Figma'dan gelen çerçeve
                    padding: '15px', 
                    borderRadius: '5px' 
                }}>
                    {/* SOL TARAF */}
                <div style={{ flex: 2, background: '#F8F8F8', border: '1px solid #C2C2C2', padding: '15px', borderRadius: '5px' }}>
    
                    {/* Telefon ve Dinamik Butonlar Alanı */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                        <label style={{ fontWeight: '500' }}>Telefon:</label>
                        <input 
                            type="text" 
                            placeholder="Numara Giriniz..."
                            data-nav-id="telefon-input"
                            value={telefon}
                            disabled={teklifId && !isMusteriGuncellemeModu}
                            onChange={(e) => setTelefon(e.target.value)}
                            onKeyDown={(e) => handleMusteriAramaKeyDown(e)}
                            style={{ width: '140px', height: '27px', background: '#FFFFFF', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }} 
                        />
                        {formModu === 'gosterim' && seciliMusteri && !isMusteriGuncellemeModu && (
                            seciliMusteri.id ? ( // Gerçek bir müşteri seçiliyse
                                <>
                                    <button type="button" onClick={handleYeniKayitClick} style={{
                                        width: '85px',
                                        height: '25px',
                                        background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                                        borderRadius: '6px',
                                        border: '0.50px black solid',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}>Yeni Kayıt
                                    </button>
                                    <button type="button" onClick={handleDuzenleClick}
                                    style={{
                                        width: '85px',
                                        height: '25px',
                                        background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                                        borderRadius: '6px',
                                        border: '0.50px black solid',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}>Düzenle
                                    </button>
                                    {teklifId && (
                                    <button 
                                        type="button" 
                                        onClick={() => setIsMusteriGuncellemeModu(true)}
                                        style={{width: '85px',
                                        height: '25px',
                                        background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                                        borderRadius: '6px',
                                        border: '0.50px black solid',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}> Güncelle
                                    </button>
                                )}
                                </>
                            ) : ( // Kayıtsız müşteri ise (id'si null)
                                <button type="button" onClick={handleYeniKayitClick}
                                    style={{
                                        width: '85px',
                                        height: '25px',
                                        background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                                        borderRadius: '6px',
                                        border: '0.50px black solid',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}>Yeni Kayıt
                                    </button>
                            )
                        )}
                        
                        {/* Müşteri güncelleme modundayken butonlar */}
                        {isMusteriGuncellemeModu && (
                            <>
                                {musteriAramaSonuclari.length === 0 && telefon.length >= 10 && (
                                    <button type="button" onClick={handleYeniKayitClick}
                                        style={{
                                            width: '85px',
                                            height: '25px',
                                            background: '#F8F8F8',
                                            borderRadius: '6px',
                                            border: '0.50px black solid',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                            fontWeight: '500'
                                        }}>Yeni Kayıt
                                    </button>
                                )}
                                <button 
                                    type="button" 
                                    onClick={() => {
                                        setIsMusteriGuncellemeModu(false);
                                        setMusteriAramaSonuclari([]);
                                    }}
                                    style={{
                                        width: '85px',
                                        height: '25px',
                                        background: '#fae1c1ff',
                                        borderRadius: '6px',
                                        border: '0.50px black solid',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}> Vazgeç
                                </button>
                            </>
                        )}
                        {(formModu === 'duzenleme' || formModu === 'yeniKayit') && (
                            <>
                                <button type="button" onClick={handleKaydet} 
                                style={{ 
                                    width: '90px',
                                    height: '25px',
                                    background: '#d8f8aeff', // Şimdilik ikisi de aynı stilde
                                    borderRadius: '8px',
                                    border: '0.50px black solid',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500' 
                                    }}>Kaydet</button>
                                <button type="button" onClick={handleFormIptal}
                                style={{   
                                    width: '90px',
                                    height: '25px',
                                    background: '#fae1c1ff', // Şimdilik ikisi de aynı stilde
                                    borderRadius: '8px',
                                    border: '0.50px black solid',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500' 
                                    }}>Vazgeç</button>
                            </>
                        )}
                    </div>

                    {/* ---- EKSİK OLAN VE YENİ EKLENEN BÖLÜM ---- */}
                    {/* Çoklu Müşteri Bulunursa Seçim Bandı veya Müşteri Güncelleme Modunda */}
                    {(musteriAramaSonuclari.length > 1 || (isMusteriGuncellemeModu && musteriAramaSonuclari.length >= 1)) && (
                        <div style={{ border: '1px solid #000000', background: '#FfFfFf', borderRadius: '4px', marginTop: '10px', padding: '10px' }}>
                            <h5 style={{ margin: '0 0 10px 0', paddingBottom: '5px', borderBottom: '1px solid #ccc' }}>Adres Seçiniz:</h5>
                             <ul className="musteri-listesi-container" style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: '600px', overflowY: 'auto' }}> 
                                {musteriAramaSonuclari.map((musteri, index) => (
                                    <li 
                                        key={musteri.id} 
                                        data-musteri-index={index}
                                        onClick={() => handleMusteriSecimi(musteri)} 
                                        style={{ 
                                            cursor: 'pointer', 
                                            padding: '15px 8px', // Dikey iç boşluğu biraz artırdık
                                            borderRadius: '3px',
                                            background: index === selectedMusteriIndex ? '#e3f2fd' : (musteri.is_last_used ? '#e8f5e9' : 'transparent'),
                                            borderBottom: '1px solid #eee',
                                            fontWeight: index === selectedMusteriIndex ? '600' : 'normal'
                                        }}
                                        onMouseEnter={e => {
                                            if (index !== selectedMusteriIndex) {
                                                e.currentTarget.style.backgroundColor = '#d1e7fd';
                                            }
                                        }}
                                        onMouseLeave={e => {
                                            if (index !== selectedMusteriIndex) {
                                                e.currentTarget.style.backgroundColor = musteri.is_last_used ? '#e8f5e9' : 'transparent';
                                            }
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            {/* SOL TARAF: Adres Bilgileri (Alt alta) */}
                                            <div>
                                                <strong style={{ fontSize: '14px', color: '#333' }}>
                                                    {musteri.ad_soyad}
                                                </strong>
                                                <div style={{ fontSize: '13px', color: '#555', marginTop: '4px' }}>
                                                    {musteri.adres}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#777', marginTop: '4px' }}>
                                                    {`${musteri.ilce || ''}, ${(musteri.il || '').toUpperCase()}`}
                                                </div>
                                            </div>
                                            
                                            {/* SAĞ TARAF: "Son Sipariş Adresi" İşareti */}
                                            {musteri.is_last_used && (
                                                <span style={{ 
                                                    color: '#2e7d32',
                                                    fontWeight: 'bold', 
                                                    fontSize: '12px',
                                                    background: '#c8e6c9',
                                                    padding: '2px 8px',
                                                    borderRadius: '10px',
                                                    flexShrink: 0, // Yazı uzun olsa bile küçülmesini engeller
                                                    marginLeft: '10px'
                                                }}>
                                                    ★ Son Adres
                                                </span>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                             {/* Güncelleme modundan çıkmak için "Vazgeç" butonu eklemek iyi bir fikir */}
                            <button type="button" onClick={() => { setMusteriAramaSonuclari([]); setIsMusteriGuncellemeModu(false); }} style={{marginTop: '10px'}}>
                                Vazgeç
                            </button>
                        </div>
                    )}
                    {/* ---- YENİ EKLENEN BÖLÜM BİTİŞ ---- */}

                    {/* Ana Form Alanları */}
                    <div style={{ borderTop: '0.5px solid #ddd', marginTop: '10px', paddingTop: '10px' }}>
                        <input 
                            type="text" name="ad_soyad" placeholder="Adı Soyadı"
                            data-nav-id="ad-soyad-input"
                            disabled={formModu === 'gosterim'}
                            value={formModu !== 'gosterim' ? adresFormData.ad_soyad : (seciliMusteri?.ad_soyad || '')}
                            onChange={handleFormChange}
                            style={{ width: '100%', boxSizing: 'border-box', padding: '8px', marginBottom: '12px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white' }} 
                        />
                        <textarea 
                            name="adres" placeholder="Adres Bilgisi" 
                            data-nav-id="adres-input"
                            disabled={formModu === 'gosterim'}
                            value={formModu !== 'gosterim' ? adresFormData.adres : (seciliMusteri?.adres || '')}
                            onChange={handleFormChange}
                            rows="3" 
                            style={{ width: '100%', boxSizing: 'border-box', padding: '10px', marginBottom: '6px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white' }}
                        ></textarea>
                        {/* İl ve ilçe dropdown'ları */}
                        <div style={{ display: 'flex', gap: '10px'}}>
                            <select name="il" data-nav-id="il-select" disabled={formModu === 'gosterim'} value={formModu !== 'gosterim' ? adresFormData.il : (seciliMusteri?.il || '')} onChange={handleFormChange} style={{ flex: 1, padding: '8px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white' }}>
                                <option value="">İl Seçiniz</option>
                                {/* ... il seçenekleri ... */}
                            {ilIlceListesi.iller.map(il => (
                                <option key={il} value={il}>{il}</option>
                            ))}      
                            </select>
                            <select name="ilce" data-nav-id="ilce-select" disabled={formModu === 'gosterim'} value={formModu !== 'gosterim' ? adresFormData.ilce : (seciliMusteri?.ilce || '')} onChange={handleFormChange} style={{ flex: 1, padding: '8px', fontFamily: 'Poppins, sans-serif', background: formModu === 'gosterim' ? '#E2E2E2' : 'white' }}>
                                <option value="">İlçe Seçiniz</option>
                                {/* ... ilçe seçenekleri ... */}
                            {ilIlceListesi.ilceler.map(ilce => (
                                <option key={ilce} value={ilce}>{ilce}</option>
                            ))}
                                
                            </select>
                        </div>
                    </div>
                </div>

                        {/* SAĞ TARAF */}
                        <div style={{ 
                            flex: 1, 
                            background: '#F8F8F8',
                            border: '1px solid #C2C2C2',
                            padding: '15px', 
                            borderRadius: '5px'
                        }}>
                            {/* --- DİNAMİK LİSTE OLUŞTURMA --- */}
                            {/* makineBaskilari dizisindeki her bir 'urun' için bir div oluşturuyoruz */}
                                {makineBaskilari.map((urun, index) => (
                                        <div key={urun.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <label>{urun.urun_adi}:</label>
                                            <input 
                                                type="number" 
                                                min="0" 
                                                data-nav-id={`makine-${urun.id}`}
                                                value={makineAdetleri[urun.id] || ''} 
                                                onChange={(e) => handleMakineAdetChange(urun.id, e.target.value)}
                                                onKeyDown={(e) => handleMakineKeyDown(e, index)}
                                                style={{ 
                                                    width: '70px',
                                                    height: '27px',
                                                    background: 'white',
                                                    border: '1px solid #ccc', 
                                                    borderRadius: '4px', 
                                                    textAlign: 'center',
                                                    boxSizing: 'border-box',
                                                    fontFamily: 'Poppins, sans-serif' 
                                                }} 
                                            />
                                        </div>
                                    ))}
                        </div>
                </div>
                <div style={{height: '5px' }}>
                </div>   

                <div style={{
                    // Dış Çerçeve Stilleri (Bu kısım doğru)
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    background: '#F8F8F8',
                    border: '1px solid #C2C2C2',
                    padding: '8px 15px',
                    borderRadius: '5px'
                }}>
                    <label style={{ fontWeight: '500' }}>Ürün Giriniz</label>

                    {/* --- YAPIYI DÜZELTEN YENİ KAPSAYICI --- */}
                    <div style={{ position: 'relative', flex: 1 }}>
                        
                        {/* ARAMA KUTUSU */}
                        <input 
                            type="text" 
                            placeholder="Ürün adı veya kodu..." 
                            data-nav-id="urun-arama-input"
                            value={urunAramaTerimi}
                            onChange={(e) => setUrunAramaTerimi(e.target.value)}
                            onKeyDown={(e) => handleUrunAramaKeyDown(e)}
                            style={{ 
                                width: '480px', // Artık kapsayıcısının %100'ünü kaplar
                                height: '30px', 
                                background: 'white', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px', 
                                padding: '5px 10px', 
                                boxSizing: 'border-box',
                                fontFamily: 'Poppins, sans-serif' 
                            }} 
                        />

                        {/* ARAMA SONUÇLARI LİSTESİ (Artık doğru kapsayıcının içinde) */}
                        {urunAramaSonuclari.length > 0 && (
                            <ul className="urun-listesi-container" style={{
                                position: 'absolute',
                                top: '100%',      // Input'un hemen altında başla
                                left: 0,          // Kapsayıcının soluna hizalan
                                right: 0,         // Kapsayıcının sağına kadar uzan
                                background: 'white',
                                border: '1px solid #ddd',
                                listStyle: 'none',
                                padding: 0,
                                margin: '2px 0 0 0', // Üstten hafif boşluk
                                zIndex: 10,
                                borderRadius: '4px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                maxHeight: '200px',
                                overflowY: 'auto'
                            }}>
                                {urunAramaSonuclari.map((urun, index) => (
                                    <li 
                                        key={urun.id} 
                                        data-urun-index={index}
                                        onClick={() => handleUrunSecimiFromAutocomplete(urun)} 
                                        style={{ 
                                            padding: '10px', 
                                            cursor: 'pointer', 
                                            borderBottom: '1px solid #eee',
                                            backgroundColor: index === selectedUrunIndex ? '#e3f2fd' : 'transparent',
                                            fontWeight: index === selectedUrunIndex ? '600' : 'normal'
                                        }}>
                                        {urun.urun_adi}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {/* --- YENİ KAPSAYICI BİTİŞ --- */}

                    <label style={{ fontWeight: '500' }}>Adet</label>
                    <input 
                        type="number"
                        data-nav-id="urun-adet-input"
                        value={aktifUrunAdet}
                        onChange={(e) => setAktifUrunAdet(e.target.value ? parseInt(e.target.value) : '')}
                        style={{ width: '65px', height: '30px', background: 'white', textAlign: 'center', border: '1px solid #ccc', borderRadius: '4px', padding: '5px', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif'  }} 
                    />
                    <button type="button" data-nav-id="urun-ekle-button" onClick={handleSepeteEkle} style={{
                        height: '27px', background: '#F8F8F8', borderRadius: '8px',
                        border: '0.50px black solid', cursor: 'pointer', padding: '0 12px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '5px'
                    }}>
                        <img src={PlusIcon} alt="Ekle" style={{ height: '12px' }} /> <span>Ürün Ekle</span>
                    </button>
                </div>
                            
            {/* SEPET TABLOSU */}
            <div style={{ marginTop: '15px' }}>
                <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid #333' }}>
                            <th style={{ ...tableCellStyle, textAlign: 'left', fontWeight: '500' }}>Ürün Adı</th>
                            <th style={{ ...tableCellStyle, ...textCenter, fontWeight: '500', width: '120px' }}>Birim Fiyat</th>
                            <th style={{ ...tableCellStyle, ...textCenter, fontWeight: '500', width: '100px' }}>Adet</th>
                            <th style={{ ...tableCellStyle, ...textCenter, fontWeight: '500', width: '120px' }}>Toplam Fiyat</th>
                            <th style={{ ...tableCellStyle, ...textCenter, fontWeight: '500', width: '80px' }}>İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sepet.length === 0 ? (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>Sepetiniz boş</td>
                            </tr>
                        ) : (
                            sepet.map((urun, index) => (
                                <tr key={`${urun.id}-${urun.urun_adi}-${index}`}>
                                    <td style={tableCellStyle}>{urun.urun_adi}</td>
                                    <td style={{ ...tableCellStyle, ...textCenter }}>
                                        {/* Fiyat Düzenleme Alanı */}
                                        {editingCell?.index === index && editingCell?.field === 'fiyat' ? (
                                            <input type="number" value={urun.fiyat} onBlur={() => setEditingCell(null)} autoFocus
                                                onChange={(e) => handleSepetChange(index, 'fiyat', e.target.value)} 
                                                style={{ 
                                                    width: '70px',
                                                    height: '27px',
                                                    background: 'white',
                                                    border: '1px solid #ccc', 
                                                    borderRadius: '4px', 
                                                    textAlign: 'center',
                                                    boxSizing: 'border-box',
                                                    fontFamily: 'Poppins, sans-serif' 
                                                }} />
                                        ) : (
                                            <>
                                                {(urun.fiyat || 0).toFixed(2)} ₺
                                                <span onClick={() => setEditingCell({ index, field: 'fiyat' })}>
                                                    <img src={EditIcon} alt="Düzenle" style={{ ...iconStyle, verticalAlign: 'middle', width: '16px', height: '16px' }} />
                                                </span>
                                            </>
                                        )}
                                    </td>
                                    <td style={{ ...tableCellStyle, ...textCenter }}>
                                        {/* ADET DÜZENLEME MANTIĞI EKLENDİ */}
                                        {!urun.isMakine && editingCell?.index === index && editingCell?.field === 'adet' ? (
                                            <input type="number" value={urun.adet} onBlur={() => setEditingCell(null)} autoFocus
                                                onChange={(e) => handleSepetChange(index, 'adet', e.target.value)} 
                                                style={{ 
                                                    width: '70px',
                                                    height: '27px',
                                                    background: 'white',
                                                    border: '1px solid #ccc', 
                                                    borderRadius: '4px', 
                                                    textAlign: 'center',
                                                    boxSizing: 'border-box',
                                                    fontFamily: 'Poppins, sans-serif' 
                                                }} />
                                        ) : (
                                            <>
                                                {urun.adet}
                                                {!urun.isMakine && (
                                                    <span onClick={() => setEditingCell({ index, field: 'adet' })}>
                                                        <img src={EditIcon} alt="Düzenle" style={{ ...iconStyle, verticalAlign: 'middle', width: '16px', height: '16px' }} />
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </td>
                                    <td style={{ ...tableCellStyle, ...textCenter }}>{((urun.fiyat || 0) * urun.adet).toFixed(2)} ₺</td>
                                    <td style={{ ...tableCellStyle, ...textCenter }}>
                                        {/* ÜRÜN SİLME MANTIĞI EKLENDİ */}
                                        {!urun.isMakine ? (
                                            <span onClick={() => handleSepetUrunSil(index)}>
                                                <img src={DeleteIcon} alt="Sil" style={{ cursor: 'pointer', width: '16px', height: '16px' }} />
                                            </span>
                                        ) : null}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* ALT BÖLÜM */}
            <div style={{ display: 'flex', marginTop: '15px', gap: '15px', borderTop: '1px solid #eee', paddingTop: '5px'}}>
            
            {/* Sol tarafı boş bırakarak finansal bölümü sağa hizalıyoruz */}
            <div style={{ flex: 1 }}></div>

            {/* Sağ Taraf - Finansal Detaylar */}
            <div style={{ 
                marginTop: '15px', 
                borderTop: '1px solid #eee', 
                paddingTop: '15px',
                display: 'flex',
                justifyContent: 'flex-end' // İçeriği sağa yaslamak için
            }}>
                
                {/* Finansal Detaylar Bölümü */}
                <div style={{ width: '300px' }}> {/* İsteğiniz üzerine sabit genişlik */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ fontWeight: '500' }}>Kargo Bedeli</label>
                        <div>
                            <input 
                                type="number" 
                                value={kargoBedeli}
                                disabled={!isKargoEditable}
                                onChange={(e) => {
                                    setKargoBedeli(parseFloat(e.target.value) || 0);
                                    setIsKargoManuallySet(true); // Kullanıcı manuel olarak değiştirdi
                                }}
                                style={{ width: '70px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'right', fontFamily: 'Poppins, sans-serif' }} 
                            />
                            <button type="button" data-nav-id="kargo-edit-button" onClick={() => setIsKargoEditable(!isKargoEditable)} style={{ marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer', padding: '5px' }}>
                                <img src={EditIcon} alt={isKargoEditable ? 'Kilitle' : 'Düzenle'} style={{ width: '16px', height: '16px', opacity: isKargoEditable ? 1 : 0.5, verticalAlign: 'middle' }} />
                            </button>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ fontWeight: '500' }}>Kapıda Ödeme</label>
                        <div>
                            <input 
                                type="number" 
                                value={kapidaOdemeBedeli}
                                disabled={!isKapidaOdemeEditable}
                                onChange={(e) => setKapidaOdemeBedeli(parseFloat(e.target.value) || 0)}
                                style={{ width: '70px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'right', fontFamily: 'Poppins, sans-serif' }} 
                            />
                            <button type="button" data-nav-id="kapida-odeme-edit-button" onClick={() => setIsKapidaOdemeEditable(!isKapidaOdemeEditable)} style={{ marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer', padding: '5px' }}>
                                <img src={EditIcon} alt={isKapidaOdemeEditable ? 'Kilitle' : 'Düzenle'} style={{ width: '16px', height: '16px', opacity: isKapidaOdemeEditable ? 1 : 0.5, verticalAlign: 'middle' }} />
                            </button>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ fontWeight: '500' }}>İndirim / Ek Bedel</label>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <input 
                                type="number" 
                                placeholder="0" 
                                data-nav-id="indirim-input"
                                value={indirim}
                                onChange={(e) => setIndirim(parseFloat(e.target.value) || 0)}
                                style={{ width: '104px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'right', fontFamily: 'Poppins, sans-serif' }} 
                            />
                            <small style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                                (+) Ek Bedel, (-) İndirim
                            </small>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <label style={{ fontWeight: '500' }}>KDV</label>
                        <button 
                            type="button"
                            data-nav-id="kdv-checkbox"
                            onClick={() => setIsKdvApplied(!isKdvApplied)}
                            style={{
                                background: isKdvApplied ? '#ffc7c1ff' : '#d4fae4ff',
                                color: 'black', border: 'none', borderRadius: '8px',
                                cursor: 'pointer', padding: '8px 18px', fontWeight: '500', border: '0.50px black solid', fontFamily: 'Poppins, sans-serif'
                            }}
                        >
                            {isKdvApplied ? 'Kaldır' : 'Ekle'}
                        </button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '2px solid #333', paddingTop: '10px' }}>
                        <strong style={{ fontSize: '18px' }}>Genel Toplam</strong>
                        <strong style={{ fontSize: '20px' }}>{genelToplam.toFixed(2)} TL</strong>
                    </div>
                </div>
            </div>
        </div>
        <div style={{ 
                marginTop: '15px', 
                borderTop: '1px solid #eee', 
                paddingTop: '15px', 
                display: 'flex', 
                justifyContent: 'flex-end', // Butonları sağa hizala
                gap: '10px' 
            }}>
            <button 
                type="button" 
                data-nav-id="vazgec-button"
                onClick={() => onClose(false)}
                style={{
                width: '110px',
                height: '37px', // Yazının rahat sığması için yüksekliği biraz artırdım
                background: '#F8F8F8',
                borderRadius: '8px',
                border: '0.50px black solid',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
            }}>
        Vazgeç
            </button>
            <button
                type="button"
                data-nav-id="kaydet-button"
                onClick={handleSubmit}
               style={{
                width: '110px',
                height: '37px',
                background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                borderRadius: '8px',
                border: '0.50px black solid',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
            }}>
                {teklifId ? 'Güncelle' : 'Kaydet'} {/* Buton metnini dinamik yapalım */}
            </button>
        </div>
    </form>
    );
}

export default TeklifGirisFormu;

